import Component from "./PuppyLeafPartyCard";
export default Component;
